import { type ComponentProps, memo } from 'react';

export type AssetMobileVersionsListTitleProps = Pick<ComponentProps<'h4'>, 'children'>;

export const AssetMobileVersionsListTitle = memo((props: AssetMobileVersionsListTitleProps) => {
  return <h4 className="font-bold ads:text-metadata text-10 text-gray-10 uppercase tracking-wider" {...props} />;
});

AssetMobileVersionsListTitle.displayName = 'AssetMobileVersionsListTitle';
